<template>
  <div class="prescription">
    <div class="u_table2" :style="u_table_heigh">
      <div class="t_head">
        <ul class="u_table_h">
          <li class="t_xh">
            <span>序号</span>
          </li>
          <li class="t_mc">
            <span>名称</span>
          </li>
          <li class="t_gg">
            <span>规格</span>
          </li>
          <li class="t_sl">
            <span>数量</span>
          </li>
          <li class="t_dw">
            <span>单位</span>
          </li>
          <li class="t_tz" v-if="!disabled">
            <span>操作</span>
          </li>
        </ul>
      </div>
      <div class="t_body" :style="u_table_scroll">
        <div class="ul_yk">
          <Ucomplete
            class="ypsrk"
            :class="{ popup_top: uc_top }"
            @on-blur="drugSearchblur"
            @on-select="changeValue3"
            :data="drug"
          ></Ucomplete>
          <input
            @blur="amount_blur"
            @keyup.enter="edit_key"
            v-model="edit_amount"
            class="edit_amount"
            type="number"
          />
          <ul
            v-for="(item, index) in drugList"
            :key="index"
            class="u_table_h"
            :class="{ active: item.active }"
          >
            <li class="t_xh">
              <span>{{ index + 1 }}</span>
            </li>
            <li class="t_mc" @click="editDrugName($event, item)">
              <span>{{ item.Drug_Name }}</span>
            </li>
            <li class="t_gg">
              <span>{{ item.specifications }}</span>
            </li>
            <li class="t_sl" @click="editAmount($event, item, 'Amount')">
              <span class="u_amount">{{ item.Amount }}</span>
            </li>
            <li class="t_dw">
              <span>{{ item.UnitName }}</span>
            </li>
            <li class="t_tz" v-if="!disabled">
              <span>
                <Button :disabled="item.delBtn" @click="del(item, index)"
                  >删除</Button
                >
              </span>
            </li>
          </ul>
          <ul class="u_table_h" v-if="!disabled">
            <li class="t_xh">
              <span>{{ drugList.length + 1 }}</span>
            </li>
            <li class="t_mc">
              <span class="input_new" @click="editDrugName($event, '')"
                >输入拼音首字母</span
              >
            </li>
            <li class="t_gg">
              <span></span>
            </li>
            <li class="t_sl">
              <span></span>
            </li>
            <li class="t_dw">
              <span></span>
            </li>
            <li class="t_tz" v-if="!disabled">
              <span></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  props: {
    drugList: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      now_symptom: [], //本次
      btnLoading: false,
      btnDisabled: false, //提交按钮禁用开关
      confirm: false,
      uc_top: false,

      // 临时药品ID 编辑药品清单用
      editDrug: null,

      //编辑药品数量
      edit_amount: "",

      // 表格高度
      u_table_heigh: { height: "" },
      u_table_scroll: { height: "" },

      // 是否新插入
      new_input: false,

      // 倒计时
      djs: null,
    };
  },
  computed: {
    ...mapGetters([
      "drug",
      "bnf", //百年方Drug_Code
    ]),
  },
  watch: {},
  methods: {
    saveData() {
      this.$emit("change");
    },
    // 药品搜索值改变时
    changeValue3(value) {
      if (value) {
        var newValue = value;
        var self = this;

        if (
          this.drugList.find((i) => i.Drug_Code == value.Drug_Code) &&
          value.Drug_Code != this.editDrug.Drug_Code
        ) {
          this.$Message.error("该药品已存在");
          return;
        }

        if (this.editDrug) {
          this.drugList.forEach((i, index) => {
            if (i.Drug_Code == this.editDrug.Drug_Code) {
              for (var Key in i) {
                i[Key] = value[Key];
              }
              i.drugTaboo = [];
            }
          });
          newValue = this.editDrug;
        } else {
          value.active = false;
          value.flevel = 0;
          value.drugTaboo = [];
          value.error = false;

          this.drugList.push(value);

          setTimeout(function () {
            self.tableRow = self.tableRow.prev();
          }, 20);
        }

        if (this.bnf.indexOf(value.Drug_Code) != -1) {
          value.Amount = 1;
        }

        setTimeout(function () {
          if (self.bnf.indexOf(value.Drug_Code) != -1) {
            $(this.$el).find(".input_new").trigger("click");
          } else {
            self.tableRow
              .find(".u_amount")
              .trigger("click", [newValue, "Amount"]);
          }
        }, 30);
      }
      $(this.$el).find(".ypsrk").css({ visibility: "hidden" });
      this.editDrug = null;
      this.saveData();
    },

    // 药品搜索框失去焦点
    drugSearchblur() {
      var self = this;
      this.djs = setTimeout(() => {
        $(this.$el).find(".ypsrk").css({ visibility: "hidden" });
      }, 100);
    },

    // 修改药品名称
    editDrugName(e, u_drug) {
      if (this.disabled) return;
      clearTimeout(this.djs);
      var offset = $(this.$el).find(e.target).position();
      $(this.$el)
        .find(".ypsrk")
        .css({
          left: offset.left,
          top: offset.top,
          width: e.target.clientWidth + "px",
          height: e.target.clientHeight,
          visibility: "visible",
        });

      let xy = $(this.$el).find(".ypsrk").offset();
      let ul_yk = $(this.$el).find(".ul_yk").offset();
      if (xy.top - $(this.$el).find(".t_body").scrollTop() > ul_yk.top + 140) {
        this.uc_top = true;
      } else {
        this.uc_top = false;
      }

      setTimeout(() => {
        $(this.$el).find(".ypsrk").find("input").focus();
      }, 110);

      this.editDrug = u_drug;

      if (u_drug) {
        this.new_input = false;
      } else {
        this.new_input = true;
      }

      // 找定位
      this.tableRow = $(this.$el).find(e.target).parents(".u_table_h");
    },
    // 修改药品数量
    editAmount(e, u_drug, type) {
      if (this.disabled) return;
      // 不改百年方的用量
      if (this.bnf.indexOf(u_drug.Drug_Code) != -1 && type == "Amount") return;

      var offset = $(this.$el).find(e.target).position();
      var edit_amount = $(this.$el).find(".edit_amount");
      edit_amount.css({
        left: offset.left,
        top: offset.top,
        width: e.target.clientWidth + "px",
        height: e.target.clientHeight,
        visibility: "visible",
      });
      setTimeout(() => {
        $(this.$el).find(edit_amount[0]).focus().select();
      }, 100);

      u_drug.type = type;
      this.edit_amount = u_drug[type];
      this.editDrug = u_drug;

      if (e.isTrusted) {
        this.new_input = false;
      } else {
        this.new_input = true;
      }
    },
    // 删除开方清单
    del(item, index) {
      this.drugList.splice(index, 1);
      this.saveData();
    },
    // 检查数量是否为空
    cj_drugList() {
      var keepGoing = true;
      var jsq = 0;
      this.drugList.forEach((i, index) => {
        if (keepGoing) {
          if (!/^\d{1,3}$/.test(i.Amount) || /^0/.test(i.Amount)) {
            this.$Message.error("处方药品数量输入错误！");
            jsq++;
            $(this.$el)
              .find($(this.$el).find(".ul_yk").find(".u_table_h")[index])
              .find(".u_amount")
              .trigger("click", [i, "Amount"]);
            keepGoing = false;
          }
        }
      });
      // 当数量不为空时跳到插入位置
      if (jsq == 0 && this.new_input) {
        $(this.$el).find(".input_new").trigger("click");
      }
      return keepGoing;
    },
    // 数量修改
    edit_key(e) {
      this.update();
      e.target.blur();
    },
    // 失去焦点
    amount_blur() {
      this.update();
      this.editDrug = null;
      this.edit_amount = "";
      this.cj_drugList();
    },
    // 当前数量更新
    update() {
      this.drugList.forEach((i, index) => {
        if (i.Drug_Code == this.editDrug.Drug_Code) {
          if (this.edit_amount) i[this.editDrug.type] = this.edit_amount;
        }
      });
      $(this.$el).find(".edit_amount").css({ visibility: "hidden" });
      setTimeout(() => {
        this.edit_amount = "";
      }, 100);
      this.saveData();
    },
    init() {},
  },
  created() {
    this.btnDisabled = false;
  },
  mounted: function () {
    $(this.$el)
      .find(".t_body")
      .scroll(function (e) {
        $(this.$el).find(".t_head").scrollLeft(e.currentTarget.scrollLeft);
      });
  },
};
</script>

<style lang="scss" scoped>
.prescription {
  height: 300px;
  .u_table2 ul.u_table_h {
    min-width: 718px;
    display: flex;
    .t_mc {
      flex: 1;
    }
  }
}
.u_table2 {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .t_body {
    flex: 1;
  }

  .t_mc .jin {
    display: inline-block;
    width: 20px;
    height: 20px;
    color: #fff;
    border-radius: 100%;
    line-height: 20px;
    font-size: 12px;
    text-align: center;
    transform: scale(0.9);

    i {
      font-style: normal;
      visibility: hidden;
    }
  }

  .isTaboo {
    .jin {
      background: #f00;

      i {
        visibility: visible;
      }
    }

    color: #f00;
  }
}
</style>

